module.exports = __webpack_public_path__ + "img/card-referrals-part-c-to-part-b.e546918d.svg";